import type {HTMLAttributes, ReactNode} from 'react';

import {cn} from '../../../helpers/cn';
import {tabBarInnerHeightClassName} from '../../constants';

export type BottomTabBarProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
};

/**
 * Bottom tab bar for mobile shell — sits as the last flex child in `AppLayout` (not `position: fixed`).
 * Safe-area padding is applied on the outer wrapper.
 */
export function BottomTabBar({children, className, ...props}: BottomTabBarProps) {
  return (
    <nav
      className={cn(
        'z-10 shrink-0 border-t border-gray-03 bg-white pb-[max(0px,env(safe-area-inset-bottom))]',
        className
      )}
      {...props}
    >
      <div className={cn('flex items-stretch', tabBarInnerHeightClassName)}>{children}</div>
    </nav>
  );
}
